"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KansaAnswerRegisterResult = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _ActionMessage = _interopRequireDefault(require("01_core/components/materials/ActionMessage"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _coreConditionActions = require("01_core/reducers/coreConditionActions");
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _KansaTgtJigyoBasicInfo = _interopRequireDefault(require("../common/components/materials/KansaTgtJigyoBasicInfo"));
var _KansaAnswerConsts = require("../common/consts/KansaAnswerConsts");
var _KansaAnswerTrailListDisp = _interopRequireDefault(require("./KansaAnswerTrailListDisp"));
var _KansaAnswerTrailListLink = _interopRequireDefault(require("./KansaAnswerTrailListLink"));
var _AnswerTable = _interopRequireDefault(require("./components/AnswerTable"));
var _ButtonFooterDisp = _interopRequireDefault(require("./components/ButtonFooterDisp"));
var _KansaBasicLabel = _interopRequireDefault(require("./components/KansaBasicLabel.js"));
var _kansaAnswerActions = require("./kansaAnswerActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const StyledCardActions = (0, _styles.styled)(_material.CardActions)(_ref => {
  let {
    theme
  } = _ref;
  return {
    textAlign: 'right',
    paddingTop: theme.spacing(0.5),
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(2)
  };
});
const StyledMarginGrid = (0, _styles.styled)(_material.Grid)({
  marginTop: 10
});

/**
 * 監査回答登録結果画面
 */
class KansaAnswerRegisterResult extends _react.default.Component {
  constructor(props) {
    super(props);
    /**
     * 監査回答情報検索処理
     */
    _defineProperty(this, "searchAnswerData", () => {
      const {
        callAPI,
        kansaInfo,
        openInfoBar,
        setEntryResult
      } = this.props;
      callAPI(_APIs.KANSA_ANSWER_INIT_SEARCH, {
        kansaTgtNendo: kansaInfo.kansaTgtNendo,
        kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId
      }).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          setEntryResult(response.data);
          this.createData(response.data);
        } else {
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
        }
      });
    });
    /**
     * 監査証跡情報検索処理
     */
    _defineProperty(this, "searchTrailData", () => {
      const {
        callAPI,
        kansaInfo,
        openInfoBar,
        setSearchTrailResult
      } = this.props;
      callAPI(_APIs.KANSA_ANSWER_TRAIL_SEARCH, {
        kansaTgtNendo: kansaInfo.kansaTgtNendo,
        kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId
      }).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          setSearchTrailResult(response.data);
        } else {
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
        }
      });
    });
    /**
     * 監査回答情報一時配列格納（見出しラベル編集）
     */
    _defineProperty(this, "createData", data => {
      (0, _KansaBasicLabel.default)(data, this.state);
    });
    this.state = {
      svData: []
    };
    const {
      dispContent,
      callAPI: _callAPI,
      kansaInfo: _kansaInfo,
      setKansaTgtJigyoBasicInfo
    } = props;
    if (_kansaAnswerActions.CONTENTS.RESULT !== dispContent) {
      // 監査対象基本情報取得
      _callAPI(_APIs.KANSA_TGT_JIGYO_BASIC, {
        kansaTgtNendo: _kansaInfo.kansaTgtNendo,
        kansaTgtJigyoId: _kansaInfo.kansaTgtJigyoId
      }).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          setKansaTgtJigyoBasicInfo(response.data);
        }
      });

      // 監査回答情報
      this.searchAnswerData();
      // 監査証跡情報
      this.searchTrailData();
    } else {
      // 監査回答結果情報
      this.createData(props.entryResult);
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {
      getCodeName,
      listState,
      kansaInfo,
      intl,
      dispContent,
      mailErrMsg,
      returnBtn,
      kansaTgtJigyoBasicInfo,
      gyomuCd
    } = this.props;
    const basicInfo = {
      kansaTgtNendoNm: kansaInfo.kansaTgtNendo + intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_NENDO
      }),
      kansaThemeNm: kansaTgtJigyoBasicInfo.kansaThemeNm,
      kansaBumonNm: kansaTgtJigyoBasicInfo.kansaBumonNm,
      kansaSekinishaNm: kansaTgtJigyoBasicInfo.kansaSekinishaNm,
      kansaTgtJigyoNm: kansaTgtJigyoBasicInfo.kansaTgtJigyoNm,
      hikansaSekinishaNm: kansaTgtJigyoBasicInfo.hikansaSekinishaNm
    };

    // 検索結果ヘッダ（監査回答）
    const columns = [{
      dataKey: 'kakuninJiko',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_KAKUNIN_JIKO
      }),
      width: 450
    }, {
      dataKey: 'kakuninKekkaCd',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_KAKUNIN_KEKKA
      }),
      hint: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_ANSWER_KEKKA_HINT
      }),
      width: 170
    }, {
      dataKey: 'kakuninHosoku',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_KAKUNIN_HOSOKU
      }),
      width: 370
    }, {
      dataKey: 'hakkenjikoBunruiCd',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_HAKKEN_JIKO_BUNRUI
      }),
      hint: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_ANSWER_HAKKENJIKO_HINT
      }),
      width: 250
    }, {
      dataKey: 'hakkenjiko',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_HAKKEN_JIKO
      }),
      width: 370
    }, {
      dataKey: 'seijukudoHyoka',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_SEJUKUDO_HYOKA
      }),
      hint: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_ANSWER_SEIJUKUDO_HINT
      }),
      width: 200
    }];
    const createRow = data => {
      // ヘッダレコードの場合（調査項目別）
      if (data.recordKbn === _KansaAnswerConsts.CONSTS.REC_HEAD_KBN) {
        const kakuninJiko = data.kakuninJiko;
        return {
          kakuninJiko
        };
        // 明細レコードの場合
      } else {
        const kakuninJiko = _stringUtil.default.emptyToHyphen(listState[data.chosaNo].kakuninJiko);
        const kakushoExp = _stringUtil.default.emptyToHyphen(listState[data.chosaNo].kakushoExp);
        const kakuninKekkaCd = getCodeName(_CodeConsts.CODE.KANSA_KKNN_RSLT.KBN, listState[data.chosaNo].kakuninKekkaCd);
        const kakuninHosoku = _stringUtil.default.emptyToHyphen(listState[data.chosaNo].kakuninHosoku);
        const hakkenjikoBunruiCd = getCodeName(_CodeConsts.CODE.KANSA_HKN_BNR.KBN, listState[data.chosaNo].hakkenjikoBunruiCd);
        const hakkenjiko = _stringUtil.default.emptyToHyphen(listState[data.chosaNo].hakkenjiko);
        const seijukudoHyoka = /*#__PURE__*/_react.default.createElement(_material.Grid, {
          container: true,
          "text-align": "left"
        }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
          size: {
            xs: 12
          },
          align: "left"
        }, intl.formatMessage({
          id: _labelConsts.LABEL.KANSA_REFERENCE_VALUE
        }), listState[data.chosaNo].referencePoints === '' ? data.referencePoints : listState[data.chosaNo].referencePoints), /*#__PURE__*/_react.default.createElement(_material.Grid, {
          size: {
            xs: 12
          },
          align: "left"
        }, intl.formatMessage({
          id: _labelConsts.LABEL.KANSA_RESULT_VALUE
        }), _stringConsts.STRING_CONSTS.FULL_SPACE, _stringUtil.default.emptyToHyphen(listState[data.chosaNo].seijukudoHyoka)));
        if (data.dispFlg) {
          return {
            kakuninJiko,
            kakushoExp,
            kakuninKekkaCd,
            kakuninHosoku,
            hakkenjikoBunruiCd,
            hakkenjiko,
            seijukudoHyoka
          };
        } else {
          return {
            kakuninJiko,
            kakushoExp,
            kakuninKekkaCd,
            kakuninHosoku,
            hakkenjikoBunruiCd,
            hakkenjiko
          };
        }
      }
    };
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage(_kansaAnswerActions.CONTENTS.RESULT === dispContent ? {
        id: _labelConsts.LABEL.KANSA_KANSA_ANSWER_RESULT
      } : {
        id: _labelConsts.LABEL.KANSA_KANSA_ANSWER_SHOW
      })
    }, /*#__PURE__*/_react.default.createElement(_material.CardContent, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 12
      },
      align: "left"
    }, _kansaAnswerActions.CONTENTS.RESULT === dispContent && /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 8
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_ActionMessage.default, {
      action: "register",
      supplement: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
        style: {
          whiteSpace: 'pre-wrap'
        }
      }, mailErrMsg))
    })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 4
      },
      align: "right"
    }, returnBtn())), _kansaAnswerActions.CONTENTS.RESULT !== dispContent && /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 12
      },
      align: "right"
    }, returnBtn()))), /*#__PURE__*/_react.default.createElement(StyledMarginGrid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_KansaTgtJigyoBasicInfo.default, {
      data: basicInfo
    }))), /*#__PURE__*/_react.default.createElement(_AnswerTable.default, {
      columns: columns,
      rowData: this.state.svData,
      createRow: createRow
    }), _kansaAnswerActions.CONTENTS.RESULT === dispContent && /*#__PURE__*/_react.default.createElement(_KansaAnswerTrailListDisp.default, null), _kansaAnswerActions.CONTENTS.RESULT !== dispContent && /*#__PURE__*/_react.default.createElement(_KansaAnswerTrailListLink.default, null)), /*#__PURE__*/_react.default.createElement(StyledCardActions, {
      disableSpacing: true
    }, /*#__PURE__*/_react.default.createElement(_ButtonFooterDisp.default, {
      gyomuCd: gyomuCd,
      btnClick: this.setBtnKind,
      returnBtn: returnBtn
    })));
  }
}
exports.KansaAnswerRegisterResult = KansaAnswerRegisterResult;
const mapStateToProps = state => {
  return {
    entries: state.kansaAnswer.entries,
    kansaInfo: state.kansaAnswer.kansaInfo,
    listState: state.kansaAnswer.listState,
    entryResult: state.kansaAnswer.entryResult,
    searchTrailResult: state.kansaAnswer.searchTrailResult,
    dispContent: state.kansaAnswer.dispContent,
    mailErrMsg: state.kansaAnswer.mailErrMsg,
    kansaTgtJigyoBasicInfo: state.kansaAnswer.kansaTgtJigyoBasicInfo,
    gyomuCd: state.kansaAnswer.searchConditions.gyomuCd
  };
};
const mapDispatchToProps = dispatch => {
  return {
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk)),
    clearDirty: () => dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](false)),
    setEntryResult: resultList => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_ENTRY_RESULT](resultList)),
    setSearchTrailResult: resultList => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_SEARCH_TRAIL_RESULT](resultList)),
    goMain: search => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.GO_MAIN](search)),
    setKansaTgtJigyoBasicInfo: kansaTgtJigyoBasicInfo => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_KANSA_TGT_JIGYO_BASIC_INFO](kansaTgtJigyoBasicInfo))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)((0, _CodeUtil.withCodeUtil)(KansaAnswerRegisterResult))));